import { SearchOutlined } from '@ant-design/icons';
import { Card, Form, Input } from 'antd';
import NumberInput from 'app/components/NumberInput/NumberInput';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IEmployeeFilters } from '../../types';

interface IProps {
  onFiltersChange: React.Dispatch<React.SetStateAction<IEmployeeFilters>>;
  filters: IEmployeeFilters;
}

const EmployeeFilters: FC<IProps> = ({ onFiltersChange, filters }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      title={t('TransportFilters.Title', 'Filters')}
      bordered={false}
      style={{ marginTop: 15 }}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ layout: 'vertical' }}
        requiredMark={true}
        id="employeeFiltersForm"
        onValuesChange={(_, values: IEmployeeFilters) =>
          onFiltersChange(values)
        }
      >
        <Form.Item name="search">
          <Input
            prefix={<SearchOutlined />}
            placeholder={t('TransportFilters.Search', 'Search')}
          />
        </Form.Item>
        <Form.Item name="birthYear">
          <NumberInput placeholder={t('Employee.Year', 'Year of birth')} />
        </Form.Item>
      </Form>
    </Card>
  );
};

export default EmployeeFilters;
